import { observer } from "mobx-react-lite";
import { FileState } from "@domain/states/order.state";
import { Minus, Plus } from "lucide-react";
import { runInAction } from "mobx";
import styles from "./counter.module.scss";

interface CounterButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  icon: React.ReactNode;
}

function CounterButton({ onClick, icon }: CounterButtonProps) {
  return (
    <button
      className={styles.button}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}

interface CounterProps {
  item: FileState;
}

export const Counter = observer(function Counter({ item }: CounterProps) {
  const handleDecrease = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    runInAction(() => {
      if (item.copiesCount > 1) {
        item.copiesCount--;
      }
    });
  };

  const handleIncrease = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    runInAction(() => {
      item.copiesCount++;
    });
  };

  return (
    <div className={styles.container}>
      <CounterButton onClick={handleDecrease} icon={<Minus />} />
      <span className={styles.value}>{item.copiesCount}</span>
      <CounterButton onClick={handleIncrease} icon={<Plus />} />
    </div>
  );
});

